import React, { ComponentState, useEffect, useState, } from "react";
import { CapMappedDataByWeek } from "./cap-report-filtrs";
import { CapNoteReportData } from "src/dataModels/reportsModel";
import moment from "moment";
import { totHoursAndMinutes } from "../documents/document-utility";
import { CapServiceGoals } from "src/dataModels/docListModel";
import { useSelector } from "react-redux";
export interface ReportProps {
  dataDocument: CapMappedDataByWeek
  clientData: CapNoteReportData
  isPrinting:boolean
}
function getDaysArray(startDate: string, endDate: string): string[] {
  let arr: string[] = [];
  let dt = new Date(startDate);

  while (dt <= new Date(endDate)) {
    arr.push(new Date(dt).toISOString().split('T')[0]);
    dt.setDate(dt.getDate() + 1);
  }

  return arr;
}
export const InterventionWithLegend = [
  { legend: "FA", name: "Full Assist" },
  { legend: "I", name: "Independant" },
  { legend: "FPP", name: "Full Physical Prompt" },
  { legend: "G", name: "Gesture" },
  { legend: "HH", name: "Hand over Hand" },
  { legend: "I", name: "Independent" },
  { legend: "M", name: "Model" },
  { legend: "N/A", name: "N/A" },
  { legend: "X", name: "Not Run" },
  { legend: "PA", name: "Partial Assist" },
  { legend: "PPP", name: "Partial Physical Prompt" },
  { legend: "VP", name: "Verbal Prompt" }
];

const AssessmentWithLegend = [
  { legend: "GM", name: "Goal Met" },
  { legend: "GNM", name: "Goal Not Met" },
  { legend: "N/A", name: "N/A" },
  { legend: "No", name: "No" },
  { legend: "NP", name: "No Progress" },
  { legend: "X", name: "Not Run" },
  { legend: "PM", name: "Progress Made" },
  { legend: "PMWP", name: "Progress Made w/Prompting" },
  { legend: "R", name: "Refuse" },
  { legend: "yes", name: "Yes" }
];
const CapServiceDataTable = (props: ReportProps) => {
  const state: ComponentState = useSelector(states => {
    return states;
  });
  const dataDocument = props.dataDocument
  const clientData = props.clientData
  const allWeekdays = getDaysArray(dataDocument.weekStart, dataDocument.weekEnd)
  const [mergedGoalsData, setMergedGoals] = useState<CapServiceGoals[]>();

  useEffect(() => {
    const uniqueGoalsMap = new Map();

    dataDocument.data.forEach(item => {
      const documentId = item.documentId;
      const capGoals = item.capNoteData?.capGoals || [];

      capGoals.forEach(goal => {
        if (!uniqueGoalsMap.has(goal.goalId)) {
          // Clone the goal object and add documentId
          uniqueGoalsMap.set(goal.goalId, { ...goal, documentId });
        }
      });
    });

    const uniqueGoalsArray = Array.from(uniqueGoalsMap.values());
    setMergedGoals(uniqueGoalsArray)
  }, [dataDocument.data])







  const renderHeaderLine1 = () => {
    return <p>
      <strong>Client Name:</strong> {`${clientData.lName},  ${clientData.fName}`} &nbsp;  <strong>MID#:</strong> {`${clientData.clientInsurance}`}&nbsp;  <strong>DOB:</strong> {`${moment(clientData.clientDob).format('M/D/YYYY')}`} &nbsp; <strong>Record #:</strong> {`${clientData.recordId}`}
    </p>
  }
  const renderHeaderLine2 = () => {
    return <p>
      <strong>Service:</strong> {`${clientData.capService}`} &nbsp; <strong>Month/Year:</strong> {`${moment(dataDocument.weekStart).format('M/YYYY')}`}
    </p>
  }
  return (

    <div className="container serviceFormTable mt-4">
      <div className="text-center">
        <h3>North Carolina Division of Mental Health/Developmental Disabilities/Substance Abuse Services</h3>
        {renderHeaderLine1()}
        {renderHeaderLine2()}
      </div>
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th className="heading-row">GOALS</th>
              <th className="Date-row">KEY</th>
              {
                allWeekdays.map((date) => <th className="Date-row">{moment(date).format('D')}</th>)
              }
            </tr>
          </thead>
          <tbody>
            {mergedGoalsData?.map((goalData) =>
              <>
                <tr>
                  <td rowSpan={2}>{goalData.goalName}</td>
                  <td>(I)</td>
                  {
                    allWeekdays.map((date) => {
                      const selectedDate = moment(date).format('M/D')
                      const documentForSelectedDate = dataDocument.data.find((docData) => moment(docData.serviceDate).format('M/D') === selectedDate)
                      if (documentForSelectedDate) {
                        const currentGoal = documentForSelectedDate.capNoteData?.capGoals?.find((goal) => goal.goalId === goalData.goalId)
                        if (currentGoal) {
                          return <td  className="Date-row">{InterventionWithLegend?.find((intervention: any) => intervention?.name === currentGoal.capInterventionName)?.legend}<br /><strong>---</strong><br />{currentGoal.noOfPrompts}</td>
                        }
                      }
                      return <td> </td>
                    })
                  }

                </tr>
                <tr>
                  <td>(A)</td>
                  {
                    allWeekdays.map((date) => {
                      const selectedDate = moment(date).format('M/D')
                      const documentForSelectedDate = dataDocument.data.find((docData) => moment(docData.serviceDate).format('M/D') === selectedDate)
                      if (documentForSelectedDate) {
                        const currentGoal = documentForSelectedDate.capNoteData?.capGoals?.find((goal) => goal.goalId === goalData.goalId)
                        if (currentGoal) {
                          return <td  className="Date-row">{AssessmentWithLegend?.find((assessment: any) => assessment?.name === currentGoal.capAssessmentName)?.legend}<br /></td>
                        }
                      }
                      return <td> </td>
                    })
                  }
                </tr>

              </>
            )}


            <tr>
              <td><strong>TIME IN/OUT</strong></td>
              <td></td>
              {
                allWeekdays.map((date) => {
                  const selectedDate = moment(date).format('M/D')
                  const documentForSelectedDate = dataDocument.data.find((docData) => moment(docData.serviceDate).format('M/D') === selectedDate)
                  const startTime = documentForSelectedDate?.documentTimeRecording?.startTime
                  const endTime = documentForSelectedDate?.documentTimeRecording?.endTime
                  return <td className="Date-row">{(startTime && endTime) ? `${moment(startTime).format('hh:mm')} / ${moment(endTime).format('hh:mm')}` : ''}</td>
                })
              }
            </tr>
            <tr>
              <td><strong>DURATION</strong></td>
              <td></td>
              {
                allWeekdays.map((date) => {
                  const selectedDate = moment(date).format('M/D')
                  const documentForSelectedDate = dataDocument.data.find((docData) => moment(docData.serviceDate).format('M/D') === selectedDate)
                  const durationVal = documentForSelectedDate?.documentTimeRecording?.totalMinutes
                  return <td className="Date-row">{durationVal ? totHoursAndMinutes(durationVal) : ''}</td>
                })
              }
            </tr>
            <tr>
              <td><strong>DATE</strong></td>
              <td></td>
              {
                allWeekdays.map((date) => {
                  const selectedDate = moment(date).format('M/D')
                  const documentForSelectedDate = dataDocument.data.some((docData) => moment(docData.serviceDate).format('M/D') === selectedDate)
                  return <td className="Date-row">{documentForSelectedDate ? selectedDate : ''}</td>
                })
              }
            </tr>
            <tr>
              <td><strong>INITIALS</strong></td>
              <td></td>
              {
                allWeekdays.map((date) => {
                  const selectedDate = moment(date).format('M/D')
                  const documentForSelectedDate = dataDocument.data.find((docData) => moment(docData.serviceDate).format('M/D') === selectedDate)
                  const txtStaffInitials = documentForSelectedDate?.documentFieldsMappings?.find((mapping) => mapping.keyName === 'txtStaffInitials')
                  return <td className="Date-row ">{(txtStaffInitials && txtStaffInitials.keyValue) ? txtStaffInitials.keyValue : ''}</td>
                })
              }
            </tr>
            <tr>
              <td><strong>Signature</strong></td>
              <td></td>
              {
                allWeekdays.map((date) => {
                  const selectedDate = moment(date).format('M/D')
                  const documentForSelectedDate = dataDocument.data.find((docData) => moment(docData.serviceDate).format('M/D') === selectedDate)
                  const signatureData = documentForSelectedDate?.documentSignatures
                  let imgUrl = 'data:image/jpeg;base64,' + signatureData?.signature;
                  return (signatureData && signatureData.signature) ?<td  className="Date-row">
                    <div>
                    <img src={imgUrl} style={{ height: "64px", width: "100%", objectFit: "fill" }} />
                      <div className="Date-row ">{`${signatureData.staffName}`} <br />
                        <strong>Date:</strong> <br />{`${moment(signatureData.dateSig).format('M/D/YYYY')}`}
                      </div>
                    </div></td> : <td></td>
                })
              }
            </tr>
          </tbody>
        </table>
      </div>
      <div className="legend">
        <strong>LEGEND</strong> <br />
        <div className="f-11">
          (I) Intervention: FA - Full Assist, FPP - Full Physical Prompt, G - Gesture, HH - Hand over Hand, I - Independent, M - Model, N/A - Not Run, PA - Partial Assist, PPP - Partial Physical Prompt, VP - Verbal Prompt
        </div>
        <div className="f-11">  (A) Assessment: GM - Goal Met, GNM - Goal Not Met, N/A - N/A, No - No, NP - No Progress, X - Not Run, PM - Progress Made, PMWP - Progress Made w/Prompting, R - Refuse, yes - Yes  </div>
      </div>


      <div className="text-center mt-6">
        <h3>North Carolina Division of Mental Health/Developmental Disabilities/Substance Abuse Services</h3>
        {renderHeaderLine1()}
        {renderHeaderLine2()}
      </div>
      <ResponsiveTable>
        <thead>
          <tr>
            <th style={{maxWidth:props.isPrinting?'20px':'50px'}}>DATE</th>
            <th>COMMENTS</th>
          </tr>
        </thead>
        <tbody>
          {
            dataDocument.data.map((docData) => {
              const commentForDoc = docData?.documentFieldsMappings?.find((mapping) => mapping.keyName === 'txtComments')
              if (!commentForDoc || !commentForDoc.keyValue) {
                return;
              }
              return <tr>
                <td style={{maxWidth:props.isPrinting?'20px':'50px'}}> {moment(docData.serviceDate).format('M/D')}</td>
                <td>{commentForDoc.keyValue}</td>
              </tr>
            })
          }
        </tbody>
      </ResponsiveTable>
    </div>
  );
};


export default CapServiceDataTable;


export const ResponsiveTable = ({ children }) => {
  return (
    <div className="table-responsive">
      <table className="table table-bordered">
        {children}
      </table>
    </div>
  );
};

